export default "__VITE_ASSET__fc3b0704__"